<template>
  <el-menu-item
      :index="index"
      :route="route"
      class="el-menu-item__custom">
    <div
        class="img-container"
        @mouseover="hover = true"
        @mouseleave="hover = false">
      <img
          :src="computedIcon"
          class="icon">
    </div>
  </el-menu-item>
</template>

<script>
export default {
  name: "MenuItemCollapsed",
  props: {
    index: {
      type: String,
      required: true,
    },
    route: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconHovered: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  computed: {
    computedIcon() {
      const currentActiveIndex = this.$parent.activeIndex;
      const isSelectedMenuItem = currentActiveIndex === this.index;

      if (this.hover || isSelectedMenuItem) {
        return this.iconHovered;
      }

      return this.icon;
    },
  },
};
</script>

<style scoped>
.icon {
  max-width: 20px;
  max-height: 20px;
  fill: #4c4c4c;
}

.el-menu-item__custom {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  padding-left: 10px !important;
}

.el-menu-item {
  border-radius: 4px;
  border: #dee5ec 0px solid;
}

.el-menu-item:not(:focus) {
  background-color: white;
}

.el-menu-item:hover {
  border: #dee5ec 1px solid;
}

.el-menu-item__custom.is-active {
  background-color: #eff8fc;
}

.img-container {
  transform: translateY(-2%);
}
</style>
